import React, { useState } from 'react';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <header className='border-b border-gray-200'>
      <div className="container mx-auto flex justify-between items-center py-1">
        <a href='/'><img src='/assets/img/Logo/Logo.svg'></img></a>

        <button
          className="md:hidden focus:outline-none"
          onClick={toggleMenu}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            ></path>
          </svg>
        </button>

        <nav className="hidden md:flex space-x-10 2xl:space-x-12">
          <a onClick={() => scrollToSection('features')}  to="/" href="#features" className="text-black font-normal">Features</a>
          <a onClick={() => scrollToSection('support')}  to="/" href="#support" className="text-black font-normal">Support</a>
          <a onClick={() => scrollToSection('about')}  to="/" href="#about" className="text-black font-normal">About</a>
          <a href="#wallet" className="text-black font-normal">Connect Wallet</a>
        </nav>
      </div>

      <div
        className={`md:hidden px-4 mt-4 transition-all duration-300 ease-in-out ${isOpen ? 'opacity-100 max-h-40' : 'opacity-0 max-h-0 overflow-hidden'
          }`}
      >
        <nav className="flex flex-col space-y-3">
          <a href="#features" className="text-black font-normal">Features</a>
          <a href="#build" className="text-black font-normal">Build</a>
          <a href="#support" className="text-black font-normal">Support</a>
          <a href="#about" className="text-black font-normal">About</a>
          <a href="#wallet" className="text-black font-normal">Connect Wallet</a>
        </nav>
      </div>
    </header>
  );
};

export default Header;